import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "../router/router";
import { Cookies } from "react-cookie";
import AvatarImage from "../common/avatarImage/avatarImage";
import "bootstrap/dist/css/bootstrap.css";
import Burger from "../common/burger/burger";
import SideNav from "./sideNav/sideNav";
import BurgerArrow from "../common/burgerArrow/burgerArrow";
import Instuctions from "../common/instructions/instructions";
import axios from "axios";

class MainApp extends Component {
    state = {
        className: "sideNav-holder",
        instClassName: "instructions",
        classNames: "hidden",
        hidden: true,
        description: null,
        descShown: false,
        burgerClicked: false,
        burgerClassName: "burger",

        resultsForChart: null,

        istest1TrialNeeded: null,
        test1Trial: null,
        test1Percent: null,

        istest2TrialNeeded: null,
        test2Trial: null,
        test2Percent: null,

        istest3TrialNeeded: null,
        test3Trial: null,
        test3Percent: null,

        istest4TrialNeeded: null,
        test4Trial: null,
        test4Percent: null,

        istest5TrialNeeded: null,
        test5Trial: null,
        test5Percent: null,

        istest6TrialNeeded: null,
        test6Trial: null,
        test6Percent: null,

        istest7TrialNeeded: null,
        test7Trial: null,
        test7Percent: null
    };

    showHide = className => {
        let classNames = className;
        this.setState({ classNames });
    };

    findIfTrialNeeded = (key, value) => {
        this.setState({ [key]: value });
        let cookie = new Cookies();
        cookie.set("trial", value, { path: "/" });
    };

    openSideNav = clicked => {
        console.log(clicked);
        let className = this.state.className;
        if (!clicked) {
            className = "sideNav-holder open";
            this.setState({ className });
        } else {
            className = "sideNav-holder";
            this.setState({ className });
        }
    };

    openInstuctions = clicked => {
        let instClassName = this.state.instClassName;
        if (!clicked) {
            instClassName = "instructions open";
            this.setState({ instClassName });
        } else {
            instClassName = "instructions";
            this.setState({ instClassName });
        }
    };

    updateTestPercent = (key, value) => {
        this.setState({ [key]: value });
        let cookie = new Cookies();
        cookie.set("percent", value, { path: "/" });
    };

    updateResultsForChart = (results, testsName) => {
        let resultsForChart = {};
        resultsForChart.results = results;
        resultsForChart.name = testsName;
        this.setState({ resultsForChart });
        localStorage.setItem("chartData", JSON.stringify(resultsForChart));
        localStorage.setItem("new", true);
        // let cookies = new Cookies();
        // cookies.set('chartData', resultsForChart, {path : '/'});
    };

    setDescription = desc => {
        let description = desc;
        this.setState({ description });
    };

    updateDescVisibility = show => {
        if (show === true) {
            console.log(show);
            this.setState({ descShown: true });
        } else {
            console.log(show);
            this.setState({ descShown: false });
        }
    };

    componentDidMount() {
        // this.openInstuctions(true);
        window.onbeforeunload = () => {
            return "dont leave me";
        };
        axios
            .get("http://psychologytest.tsu.ge/backend/studenti/authuser")
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                // window.location = "http://psychologytest.tsu.ge/";
                console.log(error);
            });

        document.addEventListener("click", e => {
            console.log(e.target);
            if (
                e.target.classList.contains("content-holder") ||
                e.target.classList.contains("testMode") ||
                e.target.classList.contains("tests-holder")
            ) {
                this.openInstuctions(true);
            }
        });

        document.querySelector("body").onkeydown = function(e) {
            if (e.keyCode === 27) {
                this.openInstuctions(true);
            }
        };
    }

    clickBurger = clicked => {
        let burgerClicked;
        if (clicked === true) {
            burgerClicked = clicked;
        } else {
            burgerClicked = this.state.burgerClicked;
        }
        console.log(clicked);
        this.openSideNav(burgerClicked);
        burgerClicked = !burgerClicked;
        if (burgerClicked) {
            let burgerClassName = "burger clickburger ";
            this.setState({ burgerClicked, burgerClassName });
        } else {
            let burgerClassName = "burger ";
            this.setState({ burgerClicked, burgerClassName });
        }
    };

    // componentWillUnmount() {

    // }

    render() {
        console.log(this.state.descShown);
        let { className, instClassName, resultsForChart } = { ...this.state };
        let classNames = this.state.classNames;
        let description = this.state.description;
        let {
            istest1TrialNeeded,
            istest2TrialNeeded,
            istest3TrialNeeded,
            istest4TrialNeeded,
            istest5TrialNeeded,
            istest6TrialNeeded,
            istest7TrialNeeded
        } = { ...this.state };
        let {
            test1Percent,
            test2Percent,
            test3Percent,
            test4Percent,
            test5Percent,
            test6Percent,
            test7Percent
        } = { ...this.state };
        return (
            <React.Fragment>
                <BrowserRouter basename="">
                    <header>
                        <Burger
                            clickBurger={this.clickBurger}
                            className={this.state.burgerClassName}
                        />
                        <AvatarImage />
                        <BurgerArrow
                            openInstuctions={this.openInstuctions}
                            descShown={this.state.descShown}
                        />
                    </header>
                    <SideNav
                        className={className}
                        clickBurger={this.clickBurger}
                    />
                    <Instuctions
                        className={instClassName}
                        description={description}
                    />
                    <Router
                        findIfTrialNeeded={this.findIfTrialNeeded}
                        updateTestPercent={this.updateTestPercent}
                        istest1TrialNeeded={istest1TrialNeeded}
                        istest2TrialNeeded={istest2TrialNeeded}
                        istest3TrialNeeded={istest3TrialNeeded}
                        istest4TrialNeeded={istest4TrialNeeded}
                        istest5TrialNeeded={istest5TrialNeeded}
                        istest6TrialNeeded={istest6TrialNeeded}
                        istest7TrialNeeded={istest7TrialNeeded}
                        test1Percent={test1Percent}
                        test2Percent={test2Percent}
                        test3Percent={test3Percent}
                        test4Percent={test4Percent}
                        test5Percent={test5Percent}
                        test6Percent={test6Percent}
                        test7Percent={test7Percent}
                        className={className}
                        instClassName={instClassName}
                        resultsForChart={resultsForChart}
                        updateResultsForChart={this.updateResultsForChart}
                        showHide={this.showHide}
                        classNames={classNames}
                        setDescription={this.setDescription}
                        updateDescVisibility={this.updateDescVisibility}
                        openInstuctions={this.openInstuctions}
                        clickBurger={this.clickBurger}
                    />
                </BrowserRouter>
            </React.Fragment>
        );
    }
}

export default MainApp;
